module.exports = __webpack_public_path__ + "img/13.d032c451.png";